module.exports = __webpack_public_path__ + "static/media/74580007-1mD0wSgs.b9034cdc.JPG";